
// All events that we can send to Prepare
export const PrepareSendMessageEvents = {
    // GET_OFFSET: 'GET_OFFSET',
    // GET_USER_LANGUAGE: 'GET_USER_LANGUAGE',
    HIDE_OVERLAY: 'HIDE_OVERLAY',
    NAVIGATE: 'NAVIGATE',
    SHOW_OVERLAY: 'SHOW_OVERLAY',
    SHOW_TOASTER: 'SHOW_TOASTER',
    RELOAD: 'RELOAD'
} as const;

// All events that we handle from Prepare
export const PrepareReceiveMessageEvents = {
    NAVIGATE: 'NAVIGATE',
    OVERLAY_CLICKED: 'OVERLAY_CLICKED',
    // PROVIDE_OFFSET: 'PROVIDE_OFFSET',
    // PROVIDE_USER_LANGUAGE: 'PROVIDE_USER_LANGUAGE',
} as const;

export type PrepareSendMessageEvent = (typeof PrepareSendMessageEvents)[keyof typeof PrepareSendMessageEvents];
